var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 208,
    viewBox: "0 0 200 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2303_632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.369 155.99H49.7V68.8854H68.6147V139.109H132.369V155.981V155.99Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.369 85.7575C141.687 85.7575 149.241 78.2036 149.241 68.8855C149.241 59.5673 141.687 52.0134 132.369 52.0134C123.05 52.0134 115.497 59.5673 115.497 68.8855C115.497 78.2036 123.05 85.7575 132.369 85.7575Z",
    fill: "#121212"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2303_632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99.5407,
    height: 103.977,
    fill: "white",
    transform: "translate(49.7 52.0134)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinea);
export default __webpack_public_path__ + "static/media/linea.7298a0d4ff0fe88bce7c8bf43a4dad03.svg";
export { ForwardRef as ReactComponent };